import { CaseListItemDto } from '@vpfa/rest-api/valuation';

export function createSharedCasePdfFileName(caseData: CaseListItemDto) {
  const dateAndTime = new Date().toISOString().substring(0, 10);

  return `${caseData.make} ${caseData.model} ${dateAndTime}`;
}
